import { FC, useEffect } from 'react'
import { Routes, Route, BrowserRouter, Navigate, useLocation } from 'react-router-dom'
import { ErrorsPage } from '../modules/errors/ErrorsPage'
import { Logout, AuthPage } from '../modules/auth'
import { App } from '../App'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import AdminRoutes from './AdminRoutes'
import UserRoutes from './UserRoutes'
import { getUserData, getUserOnboardingData, userOnboarding } from '../modules/auth/components/Frontend_Auth_Components/UserLoginRedux/UserLoginSlice'
import LandingPage from '../pages/UserPages/EndUserPages/LandingPage'
import OptOutPage from '../pages/UserPages/EndUserPages/OptOutPage'
import SuccessMessagePage from '../Components/SuccessMessagePage'
import ShortToLongUrl from '../pages/UserPages/EndUserPages/ShortToLongUrl'
import VerifyEmailAccount from '../pages/UserPages/verify-otp/VerifyOtp'
import ThirdPartySignupForm from '../Components/ThirdPartySignupForm'
import WrapperPage from '../pages/UserPages/EndUserPages/WrapperPage'
import { ENV } from '../Utils/_helpers/EnvHelper'
import ErrorBoundary from '../ErrorBoundary'
import { Error404Page } from '../modules/errors/Error404'
import { getAllUserDetails, getDefaultOptOutUrl, getUsedFeature, GetUserUsedFeature } from '../pages/UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'
import FormPage from '../pages/UserPages/EndUserPages/FormPage'
import UserOnboardingRoutes from './UserOnboardingRoutes'
import { InviteLink } from '../modules/auth/components/Frontend_Auth_Components/InviteLink'
import { RoutePaths } from './RoutePath'

import { WalletCardPublic } from '../pages/UserPages/wallet-card/WalletCardPublic'
import WalletCardDownload from '../pages/UserPages/wallet-card/components/WalletCardDownload'

const FallbackComponent = () => <Error404Page />
const AppRoutes = ({ pca }: any) => {
  const dispatch = useDispatch();
  const user = useSelector(getUserData)
  const userValues = useSelector(getAllUserDetails)
  const userOnboardingData = useSelector(getUserOnboardingData)

  const onboardingState = userValues?.onboardingStatus || user?.user?.onboardingStatus
  const onboardingCompleted = userOnboardingData?.isFinished || (['incomplete'].includes(onboardingState) ? false : true)

  const param = document.location.host
  const urlLink: any = new URL(document.location.href)
  const firstApproval = document.location.href?.split('/')?.includes('message_approval')
  const SingupFormData = urlLink?.pathname?.split('/')?.includes('login-external-first')

  const Admin = useSelector((state: any) => state?.AdminAuth?.adminData?.data?.user)
  firstApproval && localStorage.setItem('approval', document.location.href)

  const isOptOutRoute = (param === ENV().REACT_APP_OPTOUT) || (param === ENV().REACT_APP_OPTOUT_INTERNATIONAL)

  const isLoggedInUser = !!user?.user
  const isLoggedInAdmin = !!Admin
  const isAuthenticated = isLoggedInUser || isLoggedInAdmin

  // Store last URL a non-authenticated user tried to access inside the app.
  // This is later used to redirect back after a successful login.
  try {
    const currentPath = `${urlLink.pathname}${urlLink.search}`
    const isAuthPath =
      currentPath.startsWith('/auth') || currentPath.startsWith('/login-external-first')

    const isAdminAsUserRefresh = Boolean(localStorage.getItem('isAdminAsUserRefresh'))
    if (!isAuthenticated && !isAuthPath && !isAdminAsUserRefresh) {
      localStorage.setItem('redirectUrl', currentPath)
    }
  } catch (e) {
  }

  useEffect(() => {
     if (user?.user?._id) {
        dispatch(GetUserUsedFeature())
     }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.user?._id])

  return (
    <ErrorBoundary fallback={<FallbackComponent />}>
      <BrowserRouter>
        <Routes>
          <Route element={<App pca={pca} />}>
            {param === ENV().REACT_APP_SHORTURL && (
              <>
                <Route path='/*' element={<WrapperPage />} />
              </>
            )}

            <Route path='/b/*' element={<ShortToLongUrl />} />
            <Route path='/contact-form/:id' element={<FormPage />} />
            {isOptOutRoute && <Route path='/*' element={<OptOutPage />} />}
            <Route path='error/*' element={<ErrorsPage />} />
            <Route path='logout' element={<Logout />} />
            <Route path='verifyEmailAccount' element={<VerifyEmailAccount />} />
            <Route path={RoutePaths.inviteLink} element={<InviteLink />} />
            <Route path='/wallet-card/public/:cardId' element={<WalletCardPublic />} />
            <Route path='/wallet-card/download/:cardId' element={<WalletCardDownload />} />
            {/* <Route path='O/*' element={<OptOutPage />} /> */}

            {
              <>
                {user?.user !== undefined && onboardingCompleted ? (
                  <>
                    <Route path='/*' element={<UserRoutes />} />
                    <Route index element={<Navigate to='/dashboard' replace={true} />} />
                  </>
                ) : (user?.user !== undefined) && (ENV().REACT_APP_ENABLE_ONBOARDING === 'true') && !onboardingCompleted ? (
                  <>
                    <Route path='/*' element={<UserOnboardingRoutes />} />
                    <Route index element={<Navigate to='/onboarding' replace={true} />} />
                  </>
                ) : Admin ? (
                  <>
                    <Route path='/*' element={<AdminRoutes />} />
                    <Route index element={<Navigate to='/dashboard' replace={true} />} />
                  </>
                ) : (
                  <>
                    <Route path='auth/*' element={<AuthPage />} />
                    {SingupFormData && (
                      <Route path='login-external-first/*' element={<ThirdPartySignupForm />} />
                    )}
                    {firstApproval ? (
                      <Route path='*' element={<Navigate to='/auth/admin' replace={true} />} />
                    ) : (
                      <Route path='*' element={<Navigate to='/auth' replace={true} />} />
                    )}
                  </>
                )}
              </>
            }
          </Route>
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  )
}

export default AppRoutes
